import {Component, EventEmitter, Input, Output, TemplateRef, ViewChild} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {cloneDeep} from 'lodash';

@Component({
  selector: 'common-ui-daten-uebernahme',
  templateUrl: './daten-uebernahme.component.html',
  styleUrls: ['./daten-uebernahme.component.scss']
})
export class DatenUebernahmeComponent {

  @ViewChild('lgModal')
  public lgModal: BsModalRef;

  @Input()
  public context: string;

  @Input()
  public itemTemplate: TemplateRef<unknown>;

  @Input()
  public readonly;

  @Input()
  public imageOnly: boolean;
  @Output()
  public picked: EventEmitter<unknown> = new EventEmitter<unknown>();
  public internalItems: Array<unknown>;

  @Input()
  public set items(value: unknown | Array<unknown>) {
    if (!value) {
      return;
    }
    if (Array.isArray(value)) {
      this.internalItems = value;
    } else {
      this.internalItems = [value];
    }

    this.internalItems = this.internalItems.filter(item => item !== null && item !== undefined);
  }

  public pickItem(item: unknown): void {
    this.picked.emit(cloneDeep(item));
    this.lgModal.hide();
  }
}
